export default __webpack_public_path__ + "static/media/floor_plans.ac0217c2.png";